import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaSave } from "react-icons/fa";
import { useLoader } from "../../../../context/LoaderProvider.jsx";
import "./FoodBillingsetup.css";
import { getAdminBillingDataAPI, saveAdminBillingDataAPI, } from "../../../Servicefile/SettingsAndControlService.jsx";
const Foodbillingandsetup = () => {
    const { showLoader, hideLoader } = useLoader();

    const [billingData, setBillingData] = useState({});
    const [editMode, setEditMode] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchBillingData();
    }, []);


    const handlePositiveInputChange = (key, value) => {

        // Allow empty
        if (value === "") {
            handleValueChange(key, "");
            return;
        }

        // Prevent invalid numbers
        if (isNaN(value)) {
            return;
        }

        const numericValue = parseFloat(value);

        // Prevent negative values
        if (numericValue < 0) {
            return;
        }

        // Save value including 0
        handleValueChange(key, numericValue);
    };

    const fetchBillingData = async () => {
        try {
            showLoader();

            const result = await getAdminBillingDataAPI();

            setBillingData(result || {});
        } catch (error) {
            console.error("Fetch Error:", error);
        } finally {
            hideLoader();
        }
    };

    const toggleEdit = (key) => {
        setEditMode((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleValueChange = (key, value) => {
        setBillingData((prev) => {
            return {
                ...prev,
                [key]: value,
            };
        });
    };

    const handleCheckboxChange = (key) => {
        setBillingData((prev) => ({
            ...prev,
            [`${key}Visibility`]:
                !prev[`${key}Visibility`],
        }));
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            showLoader();

            const payload = {
                adminId: 1,
                ...billingData,
            };

            await saveAdminBillingDataAPI(payload);

            alert("Saved Successfully");

        } catch (error) {
            console.error("Save Error:", error);

            alert(
                error.response?.data?.message ||
                "Failed to save billing data"
            );
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    const allSections = [
        {
            title: "Dinein Charges",
            enabledKey:
                "dineinDynamicPlatformEnabled",

            visibilityKey:
                "dineinPlatformChargesVisibility",

            thresholdKey:
                "dineinPlatformThresholdAmount",

            belowKey:
                "dineinPlatformChargeBelow",

            aboveKey:
                "dineinPlatformChargeAbove",

            percentageKey:
                "dineinPlatformChargeIsPercentage",

            editKey: "dineinPlatformEdit",
        },
        {
            title: "Takeaway Charges",

            enabledKey:
                "takeawayDynamicPlatformEnabled",

            visibilityKey:
                "takeawayplatformChargesVisibility",

            thresholdKey:
                "takeawayPlatformThresholdAmount",

            belowKey:
                "takeawayPlatformChargeBelow",

            aboveKey:
                "takeawayPlatformChargeAbove",

            percentageKey:
                "takeawayPlatformChargeIsPercentage",

            editKey: "takeawayPlatformEdit",
        },
        {
            title: "Delivery Charges",

            enabledKey:
                "deliveryDynamicPlatformEnabled",

            visibilityKey:
                "deliveryplatformChargesVisibility",

            valueKey: "deliveryCharges",

            radiusKey: "deliveryRadius",

            thresholdKey:
                "deliveryPlatformThresholdAmount",

            belowKey:
                "deliveryPlatformChargeBelow",

            aboveKey:
                "deliveryPlatformChargeAbove",

            percentageKey:
                "deliveryPlatformChargeIsPercentage",

            editKey: "deliveryPlatformEdit",

            commissionField: {
                title: "Commission Charges",
                valueKey: "commissionCharges",
            },
        },


        {
            title: "Dine Out Charges",

            enabledKey:
                "tableDynamicPlatformEnabled",

            visibilityKey:
                "tableplatformChargesVisibility",

            thresholdKey:
                "tablePlatformThresholdAmount",

            belowKey:
                "tablePlatformChargeBelow",

            aboveKey:
                "tablePlatformChargeAbove",

            percentageKey:
                "tablePlatformChargeIsPercentage",

            perTableChargesKey:
                "perTableCharges",

            editKey: "tablePlatformEdit",
        },


        // {
        //     title: "Commission Charges",
        //     valueKey: "commissionCharges",
        //     visibilityKey:
        //         "commissionChargesVisibility",
        //     editKey: "commissionChargesEdit",
        // },

        {
            title: "GST",
            editKey: "gstEdit",

            gstFields: [
                {
                    title: "Platform Charges GST",
                    valueKey: "platformchargeGst",
                },

                {
                    title: "Commission Charges GST",
                    valueKey: "commissionGst",
                },

                {
                    title: "Service Charges GST",
                    valueKey: "serviceChargeGst",
                },

                {
                    title: "Packaging Charge GST",
                    valueKey: "packagingChargeGst",
                },
            ],
        },



        {
            title: "Settlements",
            editKey: "settlementsEdit",

            settlementFields: [
                {
                    title: "TDS",
                    valueKey: "tds",
                    isPercentage: true,
                },

                {
                    title: "Vendor Credit Points",
                    valueKey:
                        "vendorCreditPointsLimit",
                },

                {
                    title: "Payment Gateway Charges",
                    valueKey:
                        "paymentGatewayCharges",
                    isPercentage: true,
                },
            ],
        },


    ];

    return (
        <div style={containerStyle}>
            <div
                style={{
                    height:
                        window.innerWidth >= 1000 &&
                            window.innerWidth <= 1500
                            ? "450px"
                            : "490px",
                    overflow: "auto",
                    scrollbarWidth: "none",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                    }}
                >
                    {allSections.map(
                        (item, index) => (
                            <div
                                key={index}
                                style={
                                    cardStyle
                                }
                            >
                                {/* Top Row */}
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr auto auto",
                                        alignItems: "center",
                                        width: "100%",
                                        gap: "20px",
                                    }}
                                >
                                    {/* Left */}
                                    <div>
                                        <h3
                                            style={{
                                                margin: 0,
                                                fontSize: "15px",
                                                color: "#0f2744",
                                            }}
                                        >
                                            {item.title}
                                        </h3>
                                    </div>

                                    {/* Center Section */}
                                    {item.title !== "GST" &&
                                        item.title !== "Settlements" &&
                                        (!item.valueKey ||
                                            item.title === "Delivery Charges") &&
                                        editMode[item.editKey] && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: "30px",
                                                    marginRight: "75px"
                                                }}
                                            >
                                                {/* DYNAMIC PLATFORM */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "500",
                                                            color: "#344054",
                                                        }}
                                                    >
                                                        Dynamic Platform
                                                    </span>

                                                    <label
                                                        className="switch"
                                                        style={{
                                                            marginBottom: "0px",
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={
                                                                billingData[
                                                                item.enabledKey
                                                                ] || false
                                                            }
                                                            onChange={() =>
                                                                handleValueChange(
                                                                    item.enabledKey,
                                                                    !billingData[
                                                                    item.enabledKey
                                                                    ]
                                                                )
                                                            }
                                                        />

                                                        <span className="slider round"></span>
                                                    </label>
                                                </div>

                                                {/* VALUE */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "500",
                                                            color: "#344054",
                                                        }}
                                                    >
                                                        Value
                                                    </span>

                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            !billingData[
                                                            item.percentageKey
                                                            ]
                                                        }
                                                        onChange={() =>
                                                            handleValueChange(
                                                                item.percentageKey,
                                                                false
                                                            )
                                                        }
                                                        style={{
                                                            width: "16px",
                                                            height: "16px",
                                                            cursor: "pointer",
                                                        }}
                                                    />
                                                </div>

                                                {/* PERCENTAGE */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "500",
                                                            color: "#344054",
                                                        }}
                                                    >
                                                        Percentage
                                                    </span>

                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            billingData[
                                                            item.percentageKey
                                                            ] || false
                                                        }
                                                        onChange={() =>
                                                            handleValueChange(
                                                                item.percentageKey,
                                                                true
                                                            )
                                                        }
                                                        style={{
                                                            width: "16px",
                                                            height: "16px",
                                                            cursor: "pointer",
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                    {/* Right */}
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "18px",
                                            justifyContent: "flex-end",
                                        }}
                                    >
                                        {/* Enable / Disable */}
                                        {item.title !== "GST" &&
                                            item.title !== "Settlements" && (
                                                <>
                                                    <span
                                                        style={{
                                                            fontSize: "16px",
                                                            fontWeight: "500",
                                                            color: "#344054",
                                                            minWidth: "75px",
                                                        }}
                                                    >
                                                        {billingData[item.visibilityKey]
                                                            ? "Enabled"
                                                            : "Disabled"}
                                                    </span>

                                                    <label className="switch">
                                                        <input
                                                            type="checkbox"
                                                            disabled={
                                                                !editMode[item.editKey]
                                                            }
                                                            checked={
                                                                billingData[
                                                                item.visibilityKey
                                                                ] || false
                                                            }
                                                            onChange={() => {
                                                                if (
                                                                    !editMode[
                                                                    item.editKey
                                                                    ]
                                                                )
                                                                    return;

                                                                handleValueChange(
                                                                    item.visibilityKey,
                                                                    !billingData[
                                                                    item.visibilityKey
                                                                    ]
                                                                );
                                                            }}
                                                        />

                                                        <span className="slider round"></span>
                                                    </label>
                                                </>
                                            )}

                                        {/* Buttons */}
                                        {editMode[item.editKey] ? (
                                            <>
                                                <button
                                                    onClick={() => {
                                                        handleSave();
                                                        toggleEdit(item.editKey);
                                                    }}
                                                    style={buttonStyle}
                                                >
                                                    <FaSave />
                                                    Save
                                                </button>

                                                <button
                                                    onClick={() =>
                                                        toggleEdit(item.editKey)
                                                    }
                                                    style={{
                                                        ...buttonStyle,
                                                        background: "#6b7280",
                                                    }}
                                                >
                                                    Close
                                                </button>
                                            </>
                                        ) : (
                                            <button
                                                onClick={() =>
                                                    toggleEdit(item.editKey)
                                                }
                                                style={buttonStyle}
                                            >
                                                <FaEdit />
                                                Edit
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {/* Input Fields  */}
                                {
                                    editMode[
                                    item.editKey
                                    ] && (
                                        <div
                                            style={{
                                                // marginTop:
                                                //     "25px",

                                                display: "grid",

                                                gridTemplateColumns:
                                                    item.title === "Delivery Charges"
                                                        ? "repeat(4, 1fr)"
                                                        : (
                                                            !billingData[item.enabledKey] &&
                                                            item.title !== "GST" &&
                                                            item.title !== "Settlements"
                                                        )
                                                            ? "350px"
                                                            : item.valueKey
                                                                ? "1fr"
                                                                : "repeat(auto-fit,minmax(250px,1fr))",

                                                gap: "10px",

                                                justifyContent: "start",
                                            }}
                                        >
                                            {/* GST Fields */}
                                            {item.title === "GST" && (
                                                <div
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns:
                                                            "repeat(4,1fr)",
                                                        gap: "20px",
                                                        marginTop: "10px",
                                                    }}
                                                >
                                                    {item.gstFields.map(
                                                        (gstItem, gstIndex) => (
                                                            <div key={gstIndex}>
                                                                <label style={labelStyle}>
                                                                    {gstItem.title}
                                                                </label>

                                                                <div
                                                                    style={{
                                                                        position: "relative",
                                                                        width: item.title === "TDS" ||
                                                                            item.title === "Vendor Credit Points"
                                                                            ? "320px"
                                                                            : "100%",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="number"
                                                                        value={billingData[gstItem.valueKey] ?? ""}
                                                                        onChange={(e) =>
                                                                            handlePositiveInputChange(
                                                                                gstItem.valueKey,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        style={{
                                                                            ...inputStyle,
                                                                            width: "100%",
                                                                            paddingRight:
                                                                                "35px",
                                                                        }}
                                                                    />

                                                                    <span
                                                                        style={{
                                                                            position:
                                                                                "absolute",
                                                                            right: "14px",
                                                                            top: "50%",
                                                                            transform:
                                                                                "translateY(-50%)",
                                                                            fontSize: "16px",
                                                                            fontWeight: "600",
                                                                            color: "#667085",
                                                                        }}
                                                                    >
                                                                        %
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}

                                            {/* data not having in the referances of the productivity of its self of the barganing of the data  */}
                                            {item.valueKey && item.title !== "GST" && (
                                                <div>
                                                    <label style={labelStyle}>
                                                        {item.title === "Delivery Charges"
                                                            ? "Delivery Charges per Kilometers"
                                                            : item.title}
                                                    </label>

                                                    <div
                                                        style={{
                                                            position: "relative",
                                                            width:
                                                                item.title === "TDS" ||
                                                                    item.title === "Vendor Credit Points"
                                                                    ? "320px"
                                                                    : "100%",
                                                        }}
                                                    >
                                                        <input
                                                            type="number"
                                                            value={billingData[item.valueKey] ?? ""}
                                                            onChange={(e) =>
                                                                handlePositiveInputChange(
                                                                    item.valueKey,
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                ...inputStyle,
                                                                width: "100%",
                                                                paddingRight: "35px",
                                                            }}
                                                        />

                                                        {(item.title === "Commission Charges" ||
                                                            item.title === "TDS") && (
                                                                <span
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: "14px",
                                                                        top: "50%",
                                                                        transform:
                                                                            "translateY(-50%)",
                                                                        fontSize: "16px",
                                                                        fontWeight: "600",
                                                                        color: "#667085",
                                                                    }}
                                                                >
                                                                    %
                                                                </span>
                                                            )}
                                                    </div>
                                                </div>
                                            )}

                                            {item.title === "Delivery Charges" && (
                                                <>
                                                    <div>
                                                        <label style={labelStyle}>
                                                            Delivery Radius Kilometers
                                                        </label>

                                                        <div
                                                            style={{
                                                                position: "relative",
                                                                width: "100%",
                                                            }}
                                                        >
                                                            <input
                                                                type="number"
                                                                value={
                                                                    billingData[item.radiusKey] === 0
                                                                        ? ""
                                                                        : billingData[item.radiusKey] || ""
                                                                }
                                                                onChange={(e) =>
                                                                    handlePositiveInputChange(
                                                                        item.radiusKey,
                                                                        e.target.value
                                                                    )
                                                                }
                                                                style={{
                                                                    ...inputStyle,
                                                                    width: "100%",
                                                                    paddingRight: "35px",
                                                                }}
                                                            />

                                                            <span
                                                                style={{
                                                                    position: "absolute",
                                                                    right: "14px",
                                                                    top: "50%",
                                                                    transform:
                                                                        "translateY(-50%)",
                                                                    fontSize: "14px",
                                                                    fontWeight: "600",
                                                                    color: "#667085",
                                                                }}
                                                            >
                                                                KM
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {/* Commission Charges */}
                                                    <div>
                                                        <label style={labelStyle}>
                                                            {item.commissionField.title}
                                                        </label>

                                                        <div
                                                            style={{
                                                                position: "relative",
                                                                width: "100%",
                                                            }}
                                                        >
                                                            <input
                                                                type="number"
                                                                value={
                                                                    billingData[
                                                                        item.commissionField.valueKey
                                                                    ] === 0
                                                                        ? ""
                                                                        : billingData[
                                                                        item.commissionField.valueKey
                                                                        ] || ""
                                                                }
                                                                onChange={(e) =>
                                                                    handlePositiveInputChange(
                                                                        item.commissionField.valueKey,
                                                                        e.target.value
                                                                    )
                                                                }
                                                                style={{
                                                                    ...inputStyle,
                                                                    width: "100%",
                                                                    paddingRight: "35px",
                                                                }}
                                                            />

                                                            <span
                                                                style={{
                                                                    position: "absolute",
                                                                    right: "14px",
                                                                    top: "50%",
                                                                    transform:
                                                                        "translateY(-50%)",
                                                                    fontSize: "16px",
                                                                    fontWeight: "600",
                                                                    color: "#667085",
                                                                }}
                                                            >
                                                                %
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Delivery Radius */}

                                                </>
                                            )}
                                            {/* Platform Inputs */}
                                            {/* Platform Inputs */}
                                            {((!item.valueKey ||
                                                item.title === "Delivery Charges") &&
                                                item.title !== "GST" &&
                                                item.title !== "Settlements") && (
                                                    <>
                                                        {/* ✅ SHOW ONLY WHEN DYNAMIC PLATFORM ENABLED */}
                                                        {billingData[item.enabledKey] && (
                                                            <>
                                                                {/* Threshold Amount */}
                                                                <div>
                                                                    <label style={labelStyle}>
                                                                        Threshold Amount
                                                                    </label>

                                                                    <div
                                                                        style={{
                                                                            position: "relative",
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="number"
                                                                            value={
                                                                                billingData[item.thresholdKey] === 0
                                                                                    ? ""
                                                                                    : billingData[item.thresholdKey] || ""
                                                                            }
                                                                            onChange={(e) =>
                                                                                handlePositiveInputChange(
                                                                                    item.thresholdKey,
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            style={inputStyle}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}

                                                        {/* ✅ PLATFORM CHARGE BELOW ALWAYS SHOW */}
                                                        <div>
                                                            <label style={labelStyle}>
                                                                Platform Charge Below
                                                            </label>

                                                            <div
                                                                style={{
                                                                    position: "relative",
                                                                }}
                                                            >
                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    step="0.01"
                                                                    onKeyDown={(e) => {
                                                                        if (
                                                                            e.key === "-" ||
                                                                            e.key === "+" ||
                                                                            e.key === "e"
                                                                        ) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    value={
                                                                        billingData[item.belowKey] === 0
                                                                            ? ""
                                                                            : billingData[item.belowKey] || ""
                                                                    }
                                                                    onChange={(e) => {
                                                                        handlePositiveInputChange(
                                                                            item.belowKey,
                                                                            e.target.value
                                                                        );
                                                                    }}
                                                                    style={{
                                                                        ...inputStyle,
                                                                        width: "100%",
                                                                    }}
                                                                />

                                                                <span
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: "14px",
                                                                        top: "50%",
                                                                        transform:
                                                                            "translateY(-50%)",
                                                                        fontSize: "16px",
                                                                        fontWeight: "600",
                                                                        color: "#667085",
                                                                    }}
                                                                >
                                                                    {billingData[
                                                                        item.percentageKey
                                                                    ]
                                                                        ? "%"
                                                                        : "₹"}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        {/* ✅ SHOW ONLY WHEN DYNAMIC PLATFORM ENABLED */}
                                                        {billingData[item.enabledKey] && (
                                                            <>
                                                                {/* Platform Charge Above */}
                                                                <div>
                                                                    <label style={labelStyle}>
                                                                        Platform Charge Above
                                                                    </label>

                                                                    <div
                                                                        style={{
                                                                            position: "relative",
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="number"
                                                                            value={
                                                                                billingData[item.aboveKey] === 0
                                                                                    ? ""
                                                                                    : billingData[item.aboveKey] || ""
                                                                            }
                                                                            onChange={(e) =>
                                                                                handlePositiveInputChange(
                                                                                    item.aboveKey,
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            style={inputStyle}
                                                                        />

                                                                        <span
                                                                            style={{
                                                                                position:
                                                                                    "absolute",
                                                                                right: "14px",
                                                                                top: "50%",
                                                                                transform:
                                                                                    "translateY(-50%)",
                                                                                fontSize: "16px",
                                                                                fontWeight: "600",
                                                                                color: "#667085",
                                                                            }}
                                                                        >
                                                                            {billingData[
                                                                                item.percentageKey
                                                                            ]
                                                                                ? "%"
                                                                                : "₹"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            {/* Per Table Charges */}
                                            {item.title === "Dine Out Charges" && (
                                                <div>
                                                    <label style={labelStyle}>
                                                        Per Table Charges
                                                    </label>

                                                    <div
                                                        style={{
                                                            position: "relative",
                                                        }}
                                                    >
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            step="0.01"
                                                            value={
                                                                billingData[item.perTableChargesKey] === 0
                                                                    ? ""
                                                                    : billingData[item.perTableChargesKey] || ""
                                                            }
                                                            onChange={(e) =>
                                                                handlePositiveInputChange(
                                                                    item.perTableChargesKey,
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                ...inputStyle,
                                                                width: "100%",
                                                            }}
                                                        />

                                                        <span
                                                            style={{
                                                                position: "absolute",
                                                                right: "14px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                fontSize: "16px",
                                                                fontWeight: "600",
                                                                color: "#667085",
                                                            }}
                                                        >
                                                            ₹
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                            {/* Settlements Fields */}
                                            {item.title === "Settlements" && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        gap: "20px",
                                                        marginTop: "10px",
                                                        width: "700px",
                                                        gap: "20px"
                                                    }}
                                                >
                                                    {item.settlementFields.map(
                                                        (
                                                            settlementItem,
                                                            settlementIndex
                                                        ) => (
                                                            <div
                                                                key={settlementIndex}
                                                            >
                                                                <label style={labelStyle}>
                                                                    {
                                                                        settlementItem.title
                                                                    }
                                                                </label>

                                                                <div
                                                                    style={{
                                                                        position: "relative",
                                                                        width: "320px",
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="number"
                                                                        value={
                                                                            billingData[
                                                                                settlementItem.valueKey
                                                                            ] === 0
                                                                                ? ""
                                                                                : billingData[
                                                                                settlementItem.valueKey
                                                                                ] || ""
                                                                        }
                                                                        onChange={(e) =>
                                                                            handlePositiveInputChange(
                                                                                settlementItem.valueKey,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                        style={{
                                                                            ...inputStyle,
                                                                            width: "100%",
                                                                            paddingRight:
                                                                                "35px",
                                                                        }}
                                                                    />

                                                                    {settlementItem.isPercentage && (
                                                                        <span
                                                                            style={{
                                                                                position:
                                                                                    "absolute",
                                                                                right:
                                                                                    "14px",
                                                                                top: "50%",
                                                                                transform:
                                                                                    "translateY(-50%)",
                                                                                fontSize:
                                                                                    "16px",
                                                                                fontWeight:
                                                                                    "600",
                                                                                color:
                                                                                    "#667085",
                                                                            }}
                                                                        >
                                                                            %
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )
                                }
                            </div>
                        )
                    )}
                </div>
            </div>
        </div >
    );
};

const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "20px",
    fontFamily:
        "Segoe UI, sans-serif",
};

const cardStyle = {
    background: "#f7f7f7",
    border: "1px solid #dcdcdc",
    borderRadius: "18px",
    padding: "10px 24px",
    minHeight: "65px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
};

const inputStyle = {
    width: "100%",
    padding: "14px",
    border: "1px solid #d0d5dd",
    borderRadius: "10px",
    outline: "none",
    fontSize: "15px",
    height: "48px"
};

const buttonStyle = {
    background:
        "rgb(230 109 51)",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    padding: "6px 13px",
    // fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "17px",
    height: "34px",
    minWidth: "82px",
    justifyContent: "center",
};

const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#344054",
};

export default Foodbillingandsetup;